const getFieldFactoryFieldType = (type, field) => {
  const extraConfig = field?.extra_config && JSON.parse(field.extra_config);

  switch (type) {
    case 'PLAIN_TEXT':
      return {
        type: 'text',
        ...extraConfig
      };
    case 'PHONE_NUMBER':
      return {
        type: 'phone_number',
        should_show_otp_field: extraConfig?.is_verification_required,
        ...extraConfig
      };
    case 'EMAIL': {
      return {
        type: 'email',
        should_verify_email: extraConfig?.is_verification_required,
        ...extraConfig
      };
    }
    case 'NUMBER': {
      return {
        type: 'number',
        ...extraConfig
      };
    }
    case 'FLOAT': {
      return {
        type: 'number',
        ...extraConfig
      };
    }
    case 'LONG_TEXT': {
      return {
        type: 'textarea',
        ...extraConfig
      };
    }
    case 'DROPDOWN': {
      const options = extraConfig?.options ?? [];

      return {
        type: 'select',
        options: options,
        dependent_on_option_configs: extraConfig?.dependent_on_options_configs,
        ...extraConfig
      };
    }
    case 'RADIO_GROUP': {
      return {
        type: 'radioGroup',
        ...extraConfig
      };
    }
    case 'CHECKBOX_GROUP': {
      return {
        type: 'multiSelectCheckboxGroup',
        ...extraConfig
      };
    }
    case 'MULTI_SELECT_FIELD': {
      return {
        type: 'multiSelect',
        ...extraConfig
      };
    }
    case 'DATE': {
      return {
        type: 'datePicker',
        ...extraConfig
      };
    }
    case 'FILE_UPLOADER': {
      return {
        type: 'fileUploader',
        path_to_upload: extraConfig?.path_to_upload,
        acl_type: extraConfig?.acl_type,
        max_size_to_upload_in_mb: extraConfig?.max_size_to_upload_in_mb,
        ...extraConfig
      };
    }
    case 'COMMON_DATA_SEARCH': {
      const searchOn = extraConfig?.search_on ?? '';

      if (searchOn === 'STATE') {
        return {
          type: 'stateAsyncSelect',
          ...extraConfig
        };
      } else if (searchOn === 'DISTRICT') {
        const stateFieldName = extraConfig?.state_field_name ?? '';
        return {
          type: 'districtAsyncSelect',
          state_field_name: stateFieldName,
          ...extraConfig
        };
      } else if (searchOn === 'COUNTRY') {
        return {
          type: 'countryAsyncSelect',
          ...extraConfig
        };
      }
      return {
        type: 'asyncSelect',
        ...extraConfig
      };
    }
    case 'CHECKBOX': {
      return {
        type: 'checkbox',
        ...extraConfig
      };
    }
    case 'CONTENT': {
      return {
        type: 'content',
        ...extraConfig
      };
    }
    default: {
      throw Error(`${type} is missing`);
    }
  }
};

const getOtpFieldBasedOnType = (type, field, newField) => {
  if (type === 'PHONE_NUMBER') {
    const otpField = {
      type: 'informedOTPField',
      field: `${field}-otp`,
      label: 'OTP',
      isRelevant: true,
      relevantCondition: `values['WHO_IS_FILLING']==='PARENT'`,
      validation_type: 'string',
      validations: [
        {
          type: 'required',
          params: ['*Required']
        }
      ],
      depended_fields: [],
      placeholder: 'Enter 6 Digit OTP',
      shouldShowLabel: false,
      tags: ['NON_PII']
    };
    return otpField;
  }
  return null;
};

export const sectionDetailsConfigTransformer = (
  sectionDetailsConfig: any,
  loggedInUserRole: string
): any => {
  const allSections = [];

  sectionDetailsConfig.forEach((eachSection) => {
    if (eachSection.name_enum === 'APPLICATION_EXTRA_FIELD_SECTION') {
      return;
    }

    const entityDetails = eachSection.entities_details[0];

    if (
      entityDetails?.entity_type === 'FORM' &&
      !eachSection.parent_section_config_id
    ) {
      const formDetails = {
        order: eachSection.order,
        sectionId: eachSection.section_id,
        sectionNameEnum: eachSection.name_enum,
        title: eachSection.title,
        description: eachSection.description,
        completionPercentage: eachSection.completion_percentage,
        formId: entityDetails.form_submission_config_details.form_id,
        formSubmissionUrl: entityDetails.form_submission_url,
        sectionType: 'FORM',
        sectionCompletedAt: eachSection.section_completed_at,
        firstVisitedDatetime: eachSection.first_visited_datetime,
        extraConfig: entityDetails.extra_config,
        fields: []
      };
      allSections.push(formDetails);
    } else if (
      entityDetails?.entity_type === 'PRODUCT_REGISTRATION' &&
      !eachSection.parent_section_config_id
    ) {
      const productDetails = {
        order: eachSection.order,
        sectionId: eachSection.section_id,
        sectionNameEnum: eachSection.name_enum,
        title: eachSection.title,
        description: eachSection.description,
        completionPercentage: eachSection.completion_percentage,
        productCode:
          entityDetails.product_registration_config_details.product_code,
        productRegistrationUrl: entityDetails.product_registration_url,
        sectionType: 'PRODUCT_REGISTRATION',
        sectionCompletedAt: eachSection.section_completed_at,
        firstVisitedDatetime: eachSection.first_visited_datetime,
        extraConfig: entityDetails.extra_config,
        fields: []
      };
      allSections.push(productDetails);
    } else {
      const sectionNameEnum = eachSection.section_id;
      if (eachSection.parent_section_config_id) {
        return null;
      }

      sectionDetailsConfig.forEach((section) => {
        if (section.parent_section_config_id === sectionNameEnum) {
          const subSectionEntityDetail = section.entities_details[0];

          if (subSectionEntityDetail?.entity_type === 'PRODUCT_REGISTRATION') {
            const productDetails = {
              order: eachSection.order + section.order / 100,
              nameEnum: section.name_enum,
              sectionId: section.section_id,
              title: section.title,
              description: section.description,
              sectionNameEnum: section.name_enum,
              completionPercentage: section.completion_percentage,
              sectionCompletedAt: section.section_completed_at,
              firstVisitedDatetime: section.first_visited_datetime,
              extraConfig: subSectionEntityDetail.extra_config,
              productCode:
                subSectionEntityDetail.product_registration_config_details
                  .product_code,
              productRegistrationUrl:
                subSectionEntityDetail.product_registration_url,
              sectionType: 'PRODUCT_REGISTRATION',
              fields: [],
              parentSectionDetails: {
                title: eachSection.title,
                description: eachSection.description,
                nameEnum: eachSection.name_enum
              },
              sectionActionConfigs: section.section_action_configs
            };
            allSections.push(productDetails);
          } else if (subSectionEntityDetail?.entity_type === 'FORM') {
            const formDetails = {
              order: eachSection.order + section.order / 100,
              sectionId: section.section_id,
              sectionNameEnum: section.name_enum,
              title: section.title,
              description: section.description,
              completionPercentage: section.completion_percentage,
              sectionCompletedAt: section.section_completed_at,
              firstVisitedDatetime: section.first_visited_datetime ?? null,
              extraConfig: subSectionEntityDetail.extra_config,
              formId:
                subSectionEntityDetail.form_submission_config_details.form_id,
              formSubmissionUrl: subSectionEntityDetail.form_submission_url,
              sectionType: 'FORM',
              fields: [],

              parentSectionDetails: {
                title: eachSection.title,
                description: eachSection.description,
                nameEnum: eachSection.name_enum
              }
            };
            allSections.push(formDetails);
          } else {
            const allFields =
              subSectionEntityDetail?.template_config_details
                ?.group_config_fields ?? [];

            const subSectionDetails = {
              order: eachSection.order + section.order / 100,
              nameEnum: section.name_enum,
              sectionId: section.section_id,
              title: section.title,
              description: section.description,
              sectionCompletedAt: section.section_completed_at,
              firstVisitedDatetime: section.first_visited_datetime ?? null,
              extraConfig: subSectionEntityDetail.extra_config,
              isHidden: false,
              sectionNameEnum: section.name_enum,
              completionPercentage: section.completion_percentage,
              templateId:
                subSectionEntityDetail?.template_config_details?.template_id,
              fields: allFields,
              sectionType: 'TEMPLATE',
              parentSectionDetails: {
                title: eachSection.title,
                description: eachSection.description,
                nameEnum: eachSection.name_enum
              }
            };
            allSections.push(subSectionDetails);
          }
        }
      });
      if (entityDetails) {
        const templateDetail = {
          order: eachSection.order,
          sectionId: eachSection.section_id,
          title: eachSection.title,
          sectionType: 'TEMPLATE',
          sectionCompletedAt: eachSection.section_completed_at,
          firstVisitedDatetime: eachSection.first_visited_datetime,
          extraConfig: entityDetails.extra_config,
          sectionNameEnum: eachSection.name_enum,
          templateId: entityDetails.template_config_details?.template_id,
          description: eachSection.description,
          completionPercentage: eachSection.completion_percentage,
          fields:
            entityDetails.template_config_details?.group_config_fields ?? []
        };

        allSections.push(templateDetail);
      }
    }
  });

  allSections.sort((a, b) => a.order - b.order);

  const allFieldsMap = {};

  for (let i = 0; i < allSections.length; i++) {
    const eachSection = allSections[i];
    const sectionFields = eachSection.fields;

    const allFields = [];

    sectionFields.forEach((eachField, index) => {
      const fields = eachField.fields;
      const groupField = {
        type: 'formFieldGroup',
        field: `formFieldGroup_${index}`,
        order: eachField.order,

        form_fields: []
      };
      fields.forEach((field) => {
        let newField = {
          ...field,
          order: eachField.order + field.order / 100,
          shouldShowLabel: true
        };
        const fieldSpecificKeys = getFieldFactoryFieldType(
          newField.type,
          newField
        );

        const otpFieldBasedOnType = getOtpFieldBasedOnType(
          newField.type,
          newField.name,
          newField
        );
        let isHidden = {};
        if (
          newField.name === 'IS_DIRECT_CAMPUS_VISITED' ||
          newField.name === 'APPLICATION_TYPE'
        ) {
          isHidden = {
            isHidden: true
          };
        }
        newField = { ...newField, ...fieldSpecificKeys, ...isHidden };

        allFieldsMap[newField.id] = newField;

        const shouldUpdateFieldTypeBasedOnUserRole =
          Boolean(loggedInUserRole) &&
          (newField.name === 'WHO_IS_FILLING' ||
            newField.name === 'PERSONAL_DETAILS_HEADING_CONTENT');

        if (eachField.display_type === 'IN_LINE') {
          if (shouldUpdateFieldTypeBasedOnUserRole) {
            newField.type = 'conditionallyDependentField';
            groupField.form_fields.push(newField);
          } else {
            groupField.form_fields.push(newField);
          }
          if (otpFieldBasedOnType) {
            groupField.form_fields.push(otpFieldBasedOnType);
          }
        } else {
          if (shouldUpdateFieldTypeBasedOnUserRole) {
            newField.type = 'conditionallyDependentField';
            allFields.push(newField);
          } else {
            allFields.push(newField);
          }
          if (otpFieldBasedOnType) {
            allFields.push(otpFieldBasedOnType);
          }
        }
      });

      if (eachField.display_type === 'IN_LINE') {
        groupField.form_fields.sort((a, b) => a.order - b.order);
        allFields.push(groupField);
      }
    });
    eachSection.fields = allFields.sort((a, b) => a.order - b.order);
    if (i !== allSections.length - 1) {
      eachSection['nextSectionId'] = allSections[i + 1].sectionNameEnum;
    }
    if (i !== 0) {
      eachSection['previousSectionId'] = allSections[i - 1].sectionNameEnum;
    }
  }

  allSections.forEach((eachSection) => {
    eachSection.fields.forEach((eachField) => {
      if (eachField.type === 'formFieldGroup') {
        eachField.form_fields.forEach((eachFormField) => {
          if (eachFormField.depended_fields.length > 0) {
            eachFormField.depended_fields.forEach((eachDependedField) => {
              const value = eachDependedField.opted_value;
              const relevantCondition = `values['${eachFormField.name}'] === '${value}'`;

              if (allFieldsMap[eachDependedField.id].relevantCondition) {
                allFieldsMap[eachDependedField.id].relevantCondition =
                  allFieldsMap[eachDependedField.id].relevantCondition.concat(
                    ` || ${relevantCondition}`
                  );
              } else {
                allFieldsMap[eachDependedField.id].relevantCondition =
                  relevantCondition;
              }
            });
          }
        });
      } else if (eachField.depended_fields.length > 0) {
        eachField.depended_fields.forEach((eachDependedField) => {
          const value = eachDependedField.opted_value;
          const relevantCondition = `values['${eachField.name}'] === '${value}'`;

          if (allFieldsMap[eachDependedField.id].relevantCondition) {
            allFieldsMap[eachDependedField.id].relevantCondition = allFieldsMap[
              eachDependedField.id
            ].relevantCondition.concat(` || ${relevantCondition}`);
          } else {
            allFieldsMap[eachDependedField.id].relevantCondition =
              relevantCondition;
          }
        });
      }
    });
  });

  const fieldsGraphQlConfig = {};

  const fieldsYupValidationConfig = {};

  const fieldsTemplateResponseConfig = {};

  const templatesToGetInitialValues = [];

  allSections.forEach((eachSection) => {
    eachSection.fields.forEach((eachField) => {
      if (eachField.type === 'formFieldGroup') {
        eachField.form_fields.forEach((eachFormField) => {
          const fieldGraphQlConfig =
            eachFormField.field_response_graph_ql_config;
          if (fieldGraphQlConfig) {
            fieldsGraphQlConfig[eachFormField.name] = {
              modelName: fieldGraphQlConfig?.app_model_name,
              fieldName: fieldGraphQlConfig?.model_field_name,
              sectionId: eachSection.sectionId
            };
          } else if (
            eachFormField.response_submission_type === 'TEMPLATE_FIELD_RESPONSE'
          ) {
            fieldsTemplateResponseConfig[eachFormField.name] = {
              template_id: eachSection.templateId,
              section_id: eachSection.sectionId,
              field_id: eachFormField.id,
              field_name: eachFormField.name
            };
            fieldsTemplateResponseConfig[eachFormField.id] = {
              template_id: eachSection.templateId,
              section_id: eachSection.sectionId,
              field_id: eachFormField.id,
              field_name: eachFormField.name
            };

            if (
              templatesToGetInitialValues.indexOf(eachSection.templateId) === -1
            ) {
              templatesToGetInitialValues.push(eachSection.templateId);
            }
          }

          let validationConfig = eachFormField.validation_config;

          if (validationConfig) {
            validationConfig = JSON.parse(validationConfig);
            fieldsYupValidationConfig[eachFormField.name] =
              validationConfig.yup_validation;
          }

          const fieldId = eachFormField.id;
          if (allFieldsMap[fieldId]?.relevantCondition) {
            eachFormField['relevantCondition'] =
              allFieldsMap[fieldId].relevantCondition;
          }
        });
      } else {
        const fieldGraphQlConfig = eachField.field_response_graph_ql_config;
        if (fieldGraphQlConfig) {
          fieldsGraphQlConfig[eachField.name] = {
            modelName: fieldGraphQlConfig?.app_model_name,
            fieldName: fieldGraphQlConfig?.model_field_name,
            sectionId: eachSection.sectionId
          };
        } else if (
          eachField.response_submission_type === 'TEMPLATE_FIELD_RESPONSE'
        ) {
          fieldsTemplateResponseConfig[eachField.name] = {
            template_id: eachSection.templateId,
            section_id: eachSection.sectionId,
            field_id: eachField.id,
            field_name: eachField.name
          };
          fieldsTemplateResponseConfig[eachField.id] = {
            template_id: eachSection.templateId,
            section_id: eachSection.sectionId,
            field_id: eachField.id,
            field_name: eachField.name
          };

          if (
            templatesToGetInitialValues.indexOf(eachSection.templateId) === -1
          ) {
            templatesToGetInitialValues.push(eachSection.templateId);
          }
        }

        let validationConfig = eachField.validation_config;

        if (validationConfig) {
          validationConfig = JSON.parse(validationConfig);
          fieldsYupValidationConfig[eachField.name] =
            validationConfig.yup_validation;
        }

        const fieldId = eachField.id;
        if (allFieldsMap[fieldId]?.relevantCondition) {
          eachField['relevantCondition'] =
            allFieldsMap[fieldId].relevantCondition;
        }
      }
    });
  });

  return {
    allSections,
    fieldsGraphQlConfig,
    fieldsYupValidationConfig,
    fieldsTemplateResponseConfig,
    templatesToGetInitialValues
  };
};
